window.mmkt.config = {
  DELAY: 50,
  ANIMATION_TIME: 300,
  LOADING_DELAY: 500,
  HASH: process.env.HASH,
  VERSION: process.env.VERSION,
  API: {
    ecommerce: window.location.host === 'canarias.mediamarkt.es' ? "https://we-ecommerce-canarias-api.azurewebsites.net/v1" : "https://we-ecommerce-canarias-api-perf.azurewebsites.net/v1",
    jwt: window.location.host === 'canarias.mediamarkt.es' ? "https://we-ecommerce-canarias-api.azurewebsites.net/v1/auths/jwt" : "https://we-ecommerce-canarias-api-perf.azurewebsites.net/v1/auths/jwt",
  },
  shopifyApiKey: "2f9f9892cf0c272bcef5376b5b10e92a",
  criteoAPI: {
    baseURL: "https://d.eu.criteo.com/delivery/retailmedia",
    partnerId: 99630,
    storageKeys: {
      retailerVistorId: "criteo-api-retailer-visitor-id",
    },
  },
};
